module.exports = __webpack_public_path__ + "static/media/Authorization-for-Release-of-Medical-Information.21205c77.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/forms/Authorization-for-Release-of-Medical-Information.pdf
// module id = 30
// module chunks = 0